import React from "react";
import SalesSolutions from "../components/SalesSolutions";
import ContactForm from "../components/ContactForm";
import SellerBase from "../components/SellerBase";
import TestimonialSection from "../components/TestimonialSection";
import HeroBanner from "../components/HeroBanner";
import howitworksBanner from "../assets/images/howitworksBanner.png";

const HowItWorks = () => {
  const bannerimg = howitworksBanner;
  const tittle = "How it Works"
  return <div>
    <HeroBanner bannerimg={bannerimg} tittle={tittle} />
    <SellerBase />
    <SalesSolutions />
    <TestimonialSection />
    <ContactForm />
  </div>;
};

export default HowItWorks;
